/** Canonical creation sizes. Mirrored in backend/apps/canvas/frame_defaults.py. */
export const FRAME_DEFAULT_WIDTH = 400;
export const FRAME_DEFAULT_HEIGHT = 300;
export const HALF_TILE_H = 130;
export const WIDGET_SIZES = {
  small: { w: 180, h: 130 },
  wide: { w: 400, h: 130 },
  card: { w: 400, h: 300 },
} as const;
export type WidgetLayout = keyof typeof WIDGET_SIZES;
export const WIDGET_MIN_SIZE = WIDGET_SIZES.small;
export interface FrameSize {
  w: number;
  h: number;
}
export const WIDGET_FRAME_TYPES: ReadonlySet<string> = new Set([
  "weather",
  "chart",
  "event",
  "file",
  "link_preview",
  "todo",
  "agenda",
  "flight",
  "preview_card",
  "music",
  "calendar",
  "chat",
  "slack",
  "board",
]);
export function widgetLayoutFor(size: FrameSize): WidgetLayout {
  return size.w < 260 ? "small" : size.h < 200 ? "wide" : "card";
}
export const FRAME_TYPE_DEFAULTS: Record<string, FrameSize> = {
  taskboard: { w: 840, h: 640 },
  memory: { w: 840, h: 640 },
  dataset: { w: 840, h: 640 },
  event: WIDGET_SIZES.small,
  file: WIDGET_SIZES.small,
  weather: WIDGET_SIZES.small,
  chart: WIDGET_SIZES.small,
  link_preview: WIDGET_SIZES.wide,
};
export function getFrameDefaultSize(frameType: string): FrameSize {
  return { ...(FRAME_TYPE_DEFAULTS[frameType] ?? WIDGET_SIZES.card) };
}
export function resolveCreatedSize(
  frameType: string,
  source: { content?: unknown } = {},
): FrameSize {
  const raw = source.content;
  const content =
    raw && typeof raw === "object" && !Array.isArray(raw)
      ? (raw as Record<string, unknown>)
      : {};
  const count = (key: string) =>
    Array.isArray(content[key]) ? content[key].length : 0;
  if (frameType === "weather")
    return { ...(count("days") ? WIDGET_SIZES.card : WIDGET_SIZES.small) };
  if (frameType === "chart")
    return {
      ...(count("points") > 1 ? WIDGET_SIZES.card : WIDGET_SIZES.small),
    };
  if (frameType === "event") {
    return {
      ...(typeof content.detail === "string" && content.detail.trim()
        ? WIDGET_SIZES.wide
        : WIDGET_SIZES.small),
    };
  }
  if (frameType === "link_preview")
    return { ...(count("links") > 1 ? WIDGET_SIZES.card : WIDGET_SIZES.wide) };
  return getFrameDefaultSize(frameType);
}
